import type { MenuCategory, MenuItem } from "../types/cafe";

export const menuTabs: { id: MenuCategory; label: string; blurb: string }[] = [
  {
    id: "drinks",
    label: "Kopi & Non‑Kopi",
    blurb: "Arabika yang nyaman di lidah, disangrai medium untuk rasa halus dan rendah asam.",
  },
  {
    id: "bowls",
    label: "Rice Bowl Nusantara",
    blurb: "Masakan rumahan khas Indonesia, disajikan pas untuk makan siang yang layak.",
  },
  {
    id: "bakery",
    label: "Bakmi & Salt Bread",
    blurb: "Bakmi kenyal buatan sendiri dan roti mentega yang dipanggang setiap pagi.",
  },
];

export const menuItems: MenuItem[] = [
  {
    id: "kopi-susu-lima",
    name: "Kopi Susu Lima Detik",
    category: "drinks",
    description: "Andalan kami: double shot Arabika, susu segar, dan sentuhan gula aren.",
    price: 28000,
    tag: "Signature",
  },
  {
    id: "v60-gayo",
    name: "V60 Aceh Gayo",
    category: "drinks",
    description: "Seduh manual single origin dengan notes cokelat hitam, rempah, dan buah ara.",
    price: 35000,
  },
  {
    id: "pandan-latte",
    name: "Pandan Coconut Latte",
    category: "drinks",
    description: "Espresso di atas sirup pandan racikan sendiri dan santan yang creamy.",
    price: 32000,
  },
  {
    id: "cold-brew-tonic",
    name: "Cold Brew Tonic",
    category: "drinks",
    description: "Cold brew 18 jam dengan air tonik bersoda dan perasan jeruk kalamansi.",
    price: 34000,
  },
  {
    id: "matcha-cloud",
    name: "Matcha Cloud",
    category: "drinks",
    description: "Matcha ceremonial grade dengan susu oat, ditutup foam garam laut yang ringan.",
    price: 36000,
    tag: "Non‑kopi",
  },
  {
    id: "choco-aren",
    name: "Cokelat Aren",
    category: "drinks",
    description: "Kakao Jawa pekat dilebur dengan gula aren, tersedia panas atau dingin.",
    price: 30000,
    tag: "Non‑kopi",
  },
  {
    id: "nasi-jeruk",
    name: "Nasi Jeruk Ayam Suwir",
    category: "bowls",
    description: "Nasi harum daun jeruk, ayam suwir berbumbu, bawang goreng, dan sambal matah.",
    price: 48000,
    tag: "Terlaris",
  },
  {
    id: "nasi-cakalang",
    name: "Nasi Cakalang Rica",
    category: "bowls",
    description: "Cakalang asap dimasak rica-rica khas Manado dengan nasi melati hangat.",
    price: 52000,
  },
  {
    id: "nasi-rendang",
    name: "Rendang Rice Bowl",
    category: "bowls",
    description: "Rendang sapi masak lama, urap sayur, dan telur rebus setengah matang.",
    price: 58000,
  },
  {
    id: "nasi-tempe",
    name: "Tempe Bacem Bowl",
    category: "bowls",
    description: "Tempe dan tahu bacem manis, tumis sayur hijau, dan sambal kacang. Sepenuhnya vegetarian.",
    price: 42000,
    tag: "Vegetarian",
  },
  {
    id: "bakmi-ayam",
    name: "Bakmi Ayam Jamur",
    category: "bakery",
    description: "Mi telur kenyal, ayam kecap, jamur shiitake, dan kuah jahe bening terpisah.",
    price: 45000,
    tag: "Terlaris",
  },
  {
    id: "bakmi-chili-oil",
    name: "Bakmi Chili Oil",
    category: "bakery",
    description: "Diaduk dengan chili oil racikan sendiri, bawang putih goreng, pakcoy, dan telur setengah matang.",
    price: 46000,
  },
  {
    id: "salt-bread-original",
    name: "Salt Bread Original",
    category: "bakery",
    description: "Roti mentega dengan bagian bawah renyah dan taburan garam laut. Keluar oven jam 7 pagi.",
    price: 22000,
  },
  {
    id: "salt-bread-garlic",
    name: "Garlic Cream Salt Bread",
    category: "bakery",
    description: "Salt bread kami dibelah dan diisi krim keju bawang putih.",
    price: 28000,
  },
];
